import axiosClient from "./axiosClient";

export const getKnowledgeBases = async (storeUuid) => {
    try {
        const response = await axiosClient.get(`/stores/${storeUuid}/knowledge-bases`);
        const data = response.data.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.knowledge_bases)) return data.knowledge_bases;
        if (Array.isArray(data?.items)) return data.items;
        return [];
    } catch (error) {
        throw error;
    }
};

export const createKnowledgeBase = async (storeUuid, data) => {
    try {
        const response = await axiosClient.post(`/stores/${storeUuid}/knowledge-bases`, data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const updateKnowledgeBase = async (storeUuid, kbUuid, data) => {
    try {
        const response = await axiosClient.patch(`/stores/${storeUuid}/knowledge-bases/${kbUuid}`, data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const deleteKnowledgeBase = async (storeUuid, kbUuid) => {
    try {
        const response = await axiosClient.delete(`/stores/${storeUuid}/knowledge-bases/${kbUuid}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
